import * as styles from 'components/features/pfm/ProfileSettingsModule/ProfileSettingsModule.styl'
import * as isNumber from 'lodash/isNumber'
import { City } from 'interfaces/locations'
import { formatHousingType, formatUSCurrency } from 'helpers/formatHelpers'
import MemberProfileForm from 'components/molecules/forms/MemberProfileForm'
import DescriptionList, { DescriptionItemType } from 'components/atoms/DescriptionList'
import ButtonRow from 'components/atoms/buttons/ButtonRow'
import { getCityStateLabel, cityToOption } from 'helpers/cityHelpers'
import { showProfileEditFormActionCreator } from 'actions/settingsActions'
import { HousingType } from 'interfaces/property'
import * as formStyles from 'styles/molecules/forms/Form.css'
import { FeedUserUid } from 'interfaces/feed'
import { FORM_MEMBER_PROFILE } from 'constants/forms'
import { submitFormActionCreator } from 'actions/formActions'
import { StoreDispatch } from 'interfaces/component'
import { MemberProfileFormValues } from 'interfaces/member'
import { UserImage } from 'interfaces/userImage'
import { MemberAvatar } from 'components/features/socialFeed/Avatar/MemberAvatar'

export type ProfileSettingsModuleStateProps = {
  uid: FeedUserUid
  avatar: UserImage | null
  username?: string | null
  income: number | null
  housing_type: HousingType | null
  address1: string | null
  address2: string | null
  zip5: string | null
  city: City | null
  profileEditFormVisible: boolean
}

export type ProfileSettingsModuleDispatchProps = {
  showProfileEditForm: typeof showProfileEditFormActionCreator
}

type ProfileSettingsModuleProps = ProfileSettingsModuleStateProps & ProfileSettingsModuleDispatchProps

const ProfileSettingsModule = (props: ProfileSettingsModuleProps) => {
  const {
    uid,
    avatar,
    username,
    income,
    housing_type,
    address1,
    address2,
    zip5,
    city,
    profileEditFormVisible,
    showProfileEditForm,
  } = props

  const listItems: DescriptionItemType[] = [
    { label: 'Nickname', value: username || null, qaMarker: 'username' },
    { label: 'Annual Income', value: isNumber(income) ? formatUSCurrency(income) : null, qaMarker: 'annual-income' },
    { label: 'Housing Type', value: housing_type ? formatHousingType(housing_type) : null, qaMarker: 'housing-type' },
    { label: 'Address Line 1', value: address1 || null, qaMarker: 'address-line-1' },
    { label: 'Address Line 2', value: address2 || null, qaMarker: 'address-line-2' },
    { label: 'City, State', value: city ? getCityStateLabel(city) : null, qaMarker: 'city-state' },
    { label: 'Zip Code', value: zip5 || null, qaMarker: 'zip-code' },
  ]

  const onFormSubmit = (values: MemberProfileFormValues, dispatch: StoreDispatch) => {
    dispatch(submitFormActionCreator(FORM_MEMBER_PROFILE, values, { uid }))

    return {}
  }

  return (
    <>
      { profileEditFormVisible && (
        <MemberProfileForm
          initialValues={{
            avatar: avatar && avatar.image ? avatar.image.id : null,
            username,
            income,
            housing_type,
            address1: address1 || '',
            address2: address2 || '',
            zip5,
            city: city ? cityToOption(city) : null,
          }}
          onSubmit={ onFormSubmit }
          onCancel={ () => showProfileEditForm(false) }
        />
      )}
      { !profileEditFormVisible && (
        <div className={ formStyles.form }>
          <div className={ styles.avatarField }>
            <div className={ styles.avatarTitle }>Feed Profile Picture</div>
            <div className={ styles.avatar }>
              <MemberAvatar />
            </div>
          </div>
          <DescriptionList items={ listItems } />
          <ButtonRow
            size='small'
            buttonsPerRow={ 2 }
            buttons={ [
              { text: 'Edit', onClick: () => showProfileEditForm(true), qaMarker: 'edit-button' },
            ] }
          />
        </div>
      )}
    </>
  )
}

export default ProfileSettingsModule
